const ResidenceList = () =>
  import(/* webpackChunkName: "page-residence-list" */ '@/components/pages/residence/List.vue')
export default [
  {
    path: '',
    component: ResidenceList,
    name: 'residence-list',
    meta: {
      title: '売買用 - 居住用物件一覧',
      type: 'list',
      requiresAuth: true,
    },
  },
]
